import { render, staticRenderFns } from "./MenuContext.vue?vue&type=template&id=57c67555&"
import script from "./MenuContext.vue?vue&type=script&lang=ts&"
export * from "./MenuContext.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports